interface IRawDataMetricsVolume {
    Change: number;
    Value?: number;
}

export enum ITotalScoreTypes {
    GROWING = "Growing",
    DECLINING = "Declining",
    STAGNATING = "Stagnating",
}

export interface IRawDataMetrics {
    Volume: IRawDataMetricsVolume;
    TotalScore?: ITotalScoreTypes;
}

export interface IDemandSizeChange {
    date?: unknown;
    rawData: IRawDataMetrics;
    isLoading: boolean;
    customLabel?: string;
    labels?: Record<ITotalScoreTypes, string>;
    totalScore?: ITotalScoreTypes;
    customChangeLabel?: string;
    className?: string;
    loaderClassName?: string;
    dataAutomation?: string;
    tooltip?: string;
    isPP?: boolean;
    loaderTopGap?: string;
}

export enum ITotalScoreColors {
    GREEN = "Green",
    RED = "Red",
    GRAY = "Gray",
}

export enum ITotalScoreBgType {
    BACKGROUND = "background",
    LABEL = "label",
}
